import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

const TaskProspectsModelSchema = z
  .object({
    id: z.string(),
    task_id: z.string(),
    prospect_id: z.string()
  })
  .strict()

export const TaskProspectsModelFields = makeFieldKeys(TaskProspectsModelSchema)

export type TaskProspectsModel = z.infer<typeof TaskProspectsModelSchema>

function validateTaskProspectsModel(data: unknown): TaskProspectsModel {
  try {
    return validateWithZodSchema(TaskProspectsModelSchema, data, 'task prospects model')
  } catch (error) {
    throw new Error(`Task prospects model validation failed: ${error}`)
  }
}
